/* *******************************************************
+      BOOTSTRAP ALERTS
*********************************************************/

//+ Init Alerts Bootstrap
const alertList = document.querySelectorAll(".alert");
const alerts = [...alertList].map((element) => new bootstrap.Alert(element));


//+ Close Alert
setTimeout(function () {
  $(".alert").alert("close");
}, 5000);


/* *******************************************************
+      AOS
*********************************************************/

AOS.init({
  disable: false,
  offset: -300,
  delay: 0,
  duration: 200,
  easing: "linear",
  once: false,
  mirror: false,
});


/* *******************************************************
+       BOOTSTRAP CLASS INPUT FIELDS
*********************************************************/

function isValid(input) {
  input.removeClass("is-valid is-invalid");
  input.addClass("is-valid");
}

function isInvalid(input) {
  input.removeClass("is-valid is-invalid");
  input.addClass("is-invalid");
}

function clearField(input) {
  input.removeClass("is-valid is-invalid");
  input.val("");
}

/* *******************************************************
+       PATTERNS VALIDATIONS
*********************************************************/
//+ IS EMAIL
function isEmail(mail) {
  return /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
    $.trim(mail)
  )
    ? true
    : false;
}

//+ IS TEXT 
function isText(string) {
  return /^[a-zA-ZáéíóúñÁÉÍÓÚÑ .]*$/.test($.trim(string)) &&
    $.trim(string) !== ""
    ? true
    : false;
}

//+ IS ALPHA NUMERIC
function isAlphaNumeric(string) {
  return (
    /^[a-zA-Z0-9,.¡!@#$%^&*()_+=\-{}[\]:;<>,.¿?\/\\|áéíóúÁÉÍÓÚñÑüÜäöÄÖß]+$/.test(
      $.trim(string)
    ) && $.trim(string) !== ""
  );
}

//+ IS NUMERIC
function isNumeric(string) {
  return (
    /^[0-9\-]*$/.test(
      $.trim(string)
    ) && $.trim(string) !== ""
  );
}



//+ IS EMPTY
function isEmpty(string) {
  return $.trim(string) === "";
}

//+ IS UNDEFINED
function isUndefined(object) {
  return typeof object === "undefined";
}


/* *****************************************************
+          EXAMPLE INPUT FIELDS KEY PRESS
+                  VALIDATIONS
********************************************************
+      MAP FORM
*********************************************************/

// let formContact = {
//   content: $("#ContactForm"),
//   name: $("#ContactForm-name"),
//   email: $("#ContactForm-email"),
//   phone: $("#ContactForm-phone"),
//   message: $("#ContactForm-body"),
// };

/* *******************************************************
+       KEY PRESS
*********************************************************/

// formContact.name.on("keyup", () => {
//   if (isText(formContact.name.val())) {
//     isValid(formContact.name);
//   } else {
//     isInvalid(formContact.name);
//   }
// });

// formContact.email.on("keyup", () => {
//   if (isEmail(formContact.email.val())) {
//     isValid(formContact.email);
//   } else {
//     isInvalid(formContact.email);
//   }
// });

// formContact.phone.on("keyup", () => {
//   if (
//     formContact.phone.val().trim().length > 5 ||
//     isNumeric(formContact.phone)
//   ) {
//     isValid(formContact.phone);
//   } else {
//     isInvalid(formContact.phone);
//   }
// });